(function () {
	const collection = () => {
		$("[data-hover-opacity]").hover(
			function () {
				const id = $(this).data("hover-opacity");
				$(`[data-hover-opacity=${id}]`).addClass("opacity");
				$(this).removeClass("opacity");
			},
			function () {
				const id = $(this).data("hover-opacity");
				$(`[data-hover-opacity=${id}]`).removeClass("opacity");
			}
		);
	};

	document.addEventListener("shopify:section:load", collection);

	collection();
})();
document.addEventListener('DOMContentLoaded', () => {
    // Check each collapsible-content__item
    document.querySelectorAll('.collapsible-content__item').forEach(item => {
        const hasQuestion = item.querySelector('.collapsible-content__question') !== null;
        const hasAnswer = item.querySelector('.collapsible-content__answer') !== null;

        if (!hasQuestion || !hasAnswer) {
            item.style.display = 'none'; // Hide the parent element
        }
    });

    // Check and hide collapsible-content__heading h3 if no question exists in any item
    const itemsWithQuestions = document.querySelectorAll('.collapsible-content__item .collapsible-content__question');
    if (itemsWithQuestions.length === 0) {
        document.querySelectorAll('.collapsible-content__heading.h3').forEach(heading => {
            heading.style.display = 'none'; // Hide the heading
        });
    }
});
